import React, { useEffect } from "react";
import Helmet from "react-helmet";
import { useHistory, useParams } from "react-router-dom";
import { pluralize } from "@wrstudios/utils";
import { Comparables } from "../../comparable";
import { setPreferredCompsSection } from "../utils/storage";
import { useLive } from "../LiveProvider";
import LiveHeader from "../common/LiveHeader";
import LiveListingSubjectProperty from "../listing/LiveListingSubjectProperty";
import LiveListing from "../listing/LiveListing";

function LiveSideBySide() {
  const history = useHistory();
  const { guid } = useParams();
  const { visibleListings, sideBySideScrollPositionRef } = useLive();

  useEffect(() => {
    setPreferredCompsSection("comps");
  }, []);

  return (
    <>
      <Helmet>
        <title>Side by Side - Comps</title>
      </Helmet>
      <LiveHeader>
        {pluralize("Comparable Homes", visibleListings.length, true)}
      </LiveHeader>
      <Comparables
        hasFooter={true}
        scrollLeft={sideBySideScrollPositionRef.current}
        onScroll={(e) => {
          sideBySideScrollPositionRef.current = e.target.scrollLeft;
        }}>
        <LiveListingSubjectProperty />
        {visibleListings.map((listing) => (
          <LiveListing
            key={listing.recordId}
            listing={listing}
            onClick={(e) => {
              history.push(`/live/${guid}/comps/listing/${listing.id}`, {
                initialTab: e.target.dataset.virtualTour ? "tour" : "map",
                showFullscreenMedia: !!e.target.dataset.virtualTour
              });
            }}
          />
        ))}
      </Comparables>
    </>
  );
}

export default LiveSideBySide;
